import { createFileRoute, redirect } from '@tanstack/react-router';
import { HouseholdManagementPage } from '../pages/HouseholdManagementPage';
import { useAuthStore } from '../stores/auth-store';

export const Route = createFileRoute('/household' as any)({
  component: HouseholdManagementPage,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      });
    }
  },
});

